import { flattenSchemaErrors } from './flatten-schema-errors';
import { formatRegexes } from './format.regexes';
import {
  IFormatter,
  IFormatterDataLength,
  IFormatterDataMax,
  IFormatterDataMin,
  IFormatterDataPattern,
  IFormatterDataSchema,
  IFormatterDataJsonata,
} from './formatter.interface';

function format(msg: string, displayName?: string) {
  return `${displayName || ''} ${msg}`;
}

export const formattedErrors: Record<string, IFormatter> = {
  schema: (_displayName?: string, data?: IFormatterDataSchema) => {
    return (data?.details && flattenSchemaErrors(data?.details)) || data?.message || '';
  },
  max: (displayName?: string, data?: IFormatterDataMax) =>
    format(`cannot be more than ${data?.max ?? ''}`, displayName),
  maxlength: (displayName?: string, data?: IFormatterDataLength) =>
    format(`must be less than ${data?.requiredLength ?? ''} characters`, displayName),
  min: (displayName?: string, data?: IFormatterDataMin) => format(`must be at least ${data?.min ?? ''}`, displayName),
  minlength: (displayName?: string, data?: IFormatterDataLength) =>
    format(`must be at least ${data?.requiredLength ?? ''} characters`, displayName),
  required: (displayName?: string) => (displayName ? `${displayName} is required` : 'required'),
  pattern: (displayName?: string, data?: IFormatterDataPattern) => {
    let msg: string;
    switch (data?.requiredPattern) {
      case formatRegexes.dashesLettersNumbers.toString():
        msg = 'Can only contain dashes, letters, and numbers';
        break;
      case formatRegexes.dashesLettersNumbersSpaces.toString():
        msg = 'Can only contain dashes, letters, numbers, and spaces';
        break;
      default:
        msg = 'Contains invalid characters';
        break;
    }

    return format(msg, displayName);
  },
  unique: (displayName?: string) => format('must be unique', displayName),
  jsonata: (displayName?: string, data?: IFormatterDataJsonata) =>
    format(data?.message ? data.message : `must satisfy expression ${data?.expression ?? 'N/A'}`, displayName),
};
